import React from 'react';

interface AdminFormSectionProps {
  title: string;
  children: React.ReactNode;
}

const AdminFormSection: React.FC<AdminFormSectionProps> = ({title, children}) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

      <div className="space-y-4">
        {children}
      </div>
    </div>
  );
};

export default AdminFormSection;
